import React, { useMemo, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  makeStyles,
  AppBarProps,
  Button
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import { LogoutDialog } from 'src/components';
import { Logo } from 'src/components';
import { slices, useAppDispatch } from 'src/redux';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import useResolution from 'src/hooks/useResolution';

const { actions: userActions } = slices.user;

interface Props {
  className?: string | undefined;
  isDrawerOpen?: boolean;
  toggleDrawerOpen: () => void;
  rest?: AppBarProps;
}

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

export const TopBar = ({
  className,
  toggleDrawerOpen,
  isDrawerOpen = false,
  ...rest
}: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobile, lg_plus, isIPadAir, isIPadPro } = useResolution();

  const [logoutDialogVisibility, setLogoutDialogVisibility] = useState<boolean>(
    false
  );

  const isSmallScreen = useMemo(
    () => isMobile || lg_plus || isIPadAir || isIPadPro,
    [isIPadAir, isIPadPro, isMobile, lg_plus]
  );

  const onClickLogout = () => {
    setLogoutDialogVisibility(true);
  };

  const onDismissDialog = () => {
    setLogoutDialogVisibility(false);
  };

  const onLogOut = async () => {
    await dispatch(userActions.logout());
    navigate('/login', { replace: true });
  };

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar style={{ border: '1px solid black' }}>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        {!isSmallScreen ? (
          <Button onClick={toggleDrawerOpen} style={{ color: 'white' }}>
            {isDrawerOpen ? <MenuOpenIcon /> : <MenuIcon />}
          </Button>
        ) : null}
        <Box flexGrow={1} />
        <IconButton onClick={onClickLogout} color="inherit">
          <InputIcon />
        </IconButton>
        {isSmallScreen && (
          <Button color="inherit" onClick={toggleDrawerOpen}>
            <MenuRoundedIcon />
          </Button>
        )}
      </Toolbar>
      <LogoutDialog
        onLogout={onLogOut}
        onDismiss={onDismissDialog}
        isVisible={logoutDialogVisibility}
      />
    </AppBar>
  );
};
